<div *ngFor="let line of table">
  <div class="text-elegant mb-1 mx-1 mt-4 font-small font-weight-bold">{{ line.labels.value(language) }}</div>
  <div *ngFor="let value of line.values" class="w-100 rounded blue-grey lighten-5 p-sm-3 p-2 d-flex align-items-center mb-1">
    <div class="mr-auto">
      <div class="blue-grey-text font-weight-bold font-small">{{ value.value }}</div>
    </div>
    <mdb-badge info="true" class="z-depth-0">{{ value.type | uppercase | translate }}</mdb-badge>
  </div>
</div>